import { Component, EventEmitter } from '@angular/core';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Subscription } from 'rxjs/Subscription';
import { Router, NavigationEnd } from '@angular/router';

import { CommonService } from '../../navbar/searchCommon.service';
import { SharedService } from '../../shared/shared.service';


@Component({
    selector: 'advanced-search-model',
    templateUrl: './advancedsearch.component.html',
    styleUrls: ['./advancedsearch.component.css']
  })
export class AdvancedSearchComponent {

    searchselect: number = 0;
    customerrating: any;
    advSearchStartBtn: boolean = false;
    haveNewProjectSearchData: boolean = false;
    haveNewQuoteSearchData: boolean = false;

    projectAdvSearchFields = [];
    quoteAdvSearchFields = [];

    statusArray: any = [];
    ownerArray: any = [];
    materialArray: any = [];
    customerArray: any = [];
    quoteStatusArray: any = [];
    customerContactsArray: any = [];
    customersWithcustomerContactsDict: any = [];
    DateRangeArray: any = ['1 week', '2 weeks', '1 month', '2 months', '6 months', '1 year'];

    waiticon = '';

    private subscription: Subscription;

    modalAdvancedSearchAction = new EventEmitter<string | MaterializeAction>();
    constructor(private commonService: CommonService, private router: Router, private service: SharedService) {

    }

    ngOnInit() {

        this.router.events
        .filter(event => event instanceof NavigationEnd)
        .subscribe((event: NavigationEnd) => {
            if(!this.haveNewProjectSearchData) {
                this.projectAdvSearchFields = [];
                this.quoteAdvSearchFields = [];
            }
        });

        this.service.getCorporateInfo().subscribe(
            data => {
                let jdata = JSON.parse(data);
                this.customerArray = jdata.customers;
                this.materialArray = jdata.materials;
                this.ownerArray = jdata.owners;
                this.statusArray = jdata.statuses;
                this.quoteStatusArray = jdata.quotestatuses;
                this.customerContactsArray = jdata.customercontacts;

                let tempCustomerContactsArray = [];
                let customersDict = [];

                for (let i = 0; i < this.customerArray.length; i++) {

                for (let j = 0; j < this.customerContactsArray.length; j++) {

                        if (this.customerContactsArray[j].customer_id == this.customerArray[i].id) {
                                tempCustomerContactsArray.push(this.customerContactsArray[j]);
                            }
                        }
                    this.customersWithcustomerContactsDict[this.customerArray[i].id] = tempCustomerContactsArray;
                    tempCustomerContactsArray = [];
                }

            },
            error => {

            }
        );

        this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
            if (res.hasOwnProperty('option') && res.option === 'onAdvancedSearchEdit') {

                switch (res.value.page) {
                    case 'projects':
                        this.searchselect = 0; // open to the projects tab

                        this.projectAdvSearchFields[0] = res.value.data.name;
                        this.projectAdvSearchFields[1] = res.value.data.number;
                        this.projectAdvSearchFields[2] = res.value.data.revision;
                        this.projectAdvSearchFields[3] = res.value.data.material;
                        this.projectAdvSearchFields[4] = res.value.data.customer;
                        this.projectAdvSearchFields[5] = res.value.data.owner;
                        this.projectAdvSearchFields[6] = res.value.data.status;
                        this.projectAdvSearchFields[7] = res.value.data.createddays;
                        this.projectAdvSearchFields[8] = res.value.data.createddate;
                    break;
                    case 'quotes':
                        this.searchselect = 1; // open to the quotes tab

                        this.quoteAdvSearchFields[0] = res.value.data.number;
                        this.quoteAdvSearchFields[1] = res.value.data.createddays;
                        this.quoteAdvSearchFields[2] = res.value.data.createddate;
                        this.quoteAdvSearchFields[3] = res.value.data.RFQ;
                        this.quoteAdvSearchFields[4] = res.value.data.customer;
                        this.quoteAdvSearchFields[5] = res.value.data.contact;
                        this.quoteAdvSearchFields[6] = res.value.data.duedays;
                        this.quoteAdvSearchFields[7] = res.value.data.duedate;
                        this.quoteAdvSearchFields[8] = res.value.data.owner;
                        this.quoteAdvSearchFields[9] = res.value.data.status;
                        this.quoteAdvSearchFields[10] = res.value.data.expireddays;
                        this.quoteAdvSearchFields[11] = res.value.data.expireddate;
                    break;
                }

                this.modalAdvancedSearchAction.emit({ action: 'modal', params: ['open'] });
            }  else if (res.hasOwnProperty('option') && res.option === 'setNewPageAdvancedSearchData') {


                switch (res.value.page) {
                    case 'projects':
                        this.projectAdvSearchFields = [];
                        this.haveNewProjectSearchData = true;
                        this.searchselect = 0;
                        this.projectAdvSearchFields[0] = res.value.data.name;
                        this.projectAdvSearchFields[1] = res.value.data.number;
                        this.projectAdvSearchFields[2] = res.value.data.revision;
                        this.projectAdvSearchFields[3] = res.value.data.material;
                        this.projectAdvSearchFields[4] = res.value.data.customer;
                        this.projectAdvSearchFields[5] = res.value.data.owner;
                        this.projectAdvSearchFields[6] = res.value.data.status;
                        this.projectAdvSearchFields[7] = res.value.data.createddays;
                        this.projectAdvSearchFields[8] = res.value.data.createddate;
                    break;
                    case 'quotes':
                        this.quoteAdvSearchFields = [];
                        this.haveNewQuoteSearchData = true;
                        this.searchselect = 1; // open to the quotes tab
                        this.quoteAdvSearchFields[0] = res.value.data.number;
                        this.quoteAdvSearchFields[1] = res.value.data.createddays;
                        this.quoteAdvSearchFields[2] = res.value.data.createddate;
                        this.quoteAdvSearchFields[3] = res.value.data.RFQ;
                        this.quoteAdvSearchFields[4] = res.value.data.customer;
                        this.quoteAdvSearchFields[5] = res.value.data.contact;
                        this.quoteAdvSearchFields[6] = res.value.data.duedays;
                        this.quoteAdvSearchFields[7] = res.value.data.duedate;
                        this.quoteAdvSearchFields[8] = res.value.data.owner;
                        this.quoteAdvSearchFields[9] = res.value.data.status;
                        this.quoteAdvSearchFields[10] = res.value.data.expireddays;
                        this.quoteAdvSearchFields[11] = res.value.data.expireddate;
                    break;
                }
            } else if (res.hasOwnProperty('option') && res.option === 'getPageSearchData') {
                console.log('getNewPageSearchData...', res);

                if (this.haveNewProjectSearchData || this.haveNewQuoteSearchData) {
                    switch (res.value) {
                        case 'projects':
                            this.searchselect = 0;
                            this.haveNewProjectSearchData = false;
                            this.sendSearchData();
                        break;
                        case 'quotes':
                            this.searchselect = 1;
                            this.haveNewQuoteSearchData = false;
                            this.sendSearchData();
                        break;
                    }
                }
            }
        });
    }

    openModalAdvancedSearch() {
        this.projectAdvSearchFields = [];
        this.quoteAdvSearchFields = [];
        this.advSearchStartBtn = false;
        if (this.router.url === '/projects') {
            this.searchselect = 0;
        } else if (this.router.url === '/quote') {
            this.searchselect = 1;
        } else {
            this.searchselect = 0;
        }
        this.modalAdvancedSearchAction.emit({ action: 'modal', params: ['open'] });
    }

    onChangeEvent() {
        if ((this.quoteAdvSearchFields.length > 0 && this.searchselect == 1) || (this.projectAdvSearchFields.length > 0 && this.searchselect == 0)) {
            this.advSearchStartBtn = true;
        } else {
            this.advSearchStartBtn = false;
        }
    }

    sendSearchData() {


        let advancedSearchJSONbody = {};

        // Projects search
        if (Number(this.searchselect) == 0) {

            if (this.projectAdvSearchFields.length == 0) {
                return;
            }
            console.log('search terms', this.projectAdvSearchFields);

            if (this.projectAdvSearchFields[0]) {
                advancedSearchJSONbody['name'] = this.projectAdvSearchFields[0];
            }
            if (this.projectAdvSearchFields[1]) {
                advancedSearchJSONbody['number'] = this.projectAdvSearchFields[1];
            }
            if (this.projectAdvSearchFields[2]) {
                advancedSearchJSONbody['revision'] = this.projectAdvSearchFields[2];
            }
            if (this.projectAdvSearchFields[3]) {
                advancedSearchJSONbody['material'] = Number(this.projectAdvSearchFields[3]);
            }
            if (this.projectAdvSearchFields[4]) {
                advancedSearchJSONbody['customer'] = Number(this.projectAdvSearchFields[4]);
                }
            if (this.projectAdvSearchFields[5]) {
                advancedSearchJSONbody['owner'] = Number(this.projectAdvSearchFields[5]);
            }
            if (this.projectAdvSearchFields[6]) {
                advancedSearchJSONbody['status'] = Number(this.projectAdvSearchFields[6]);
            }
            if (this.projectAdvSearchFields[7]) {
                advancedSearchJSONbody['createddays'] = Number(this.projectAdvSearchFields[7]);
                }
            if (this.projectAdvSearchFields[8]) {
                advancedSearchJSONbody['createddate'] = this.projectAdvSearchFields[8];
            }

            console.log(advancedSearchJSONbody);
            this.commonService.notifyOther({ option: 'onAdvancedSearch', value: {page: 'projects', data: advancedSearchJSONbody}});
            this.projectAdvSearchFields = [];
        } else if (Number(this.searchselect) == 1) {

            if (this.quoteAdvSearchFields.length == 0) {
                return;
            }

            if (this.quoteAdvSearchFields[0]) {
                advancedSearchJSONbody['number'] = Number(this.quoteAdvSearchFields[0]);
            }
            if (this.quoteAdvSearchFields[1]) {
                advancedSearchJSONbody['createddays'] = Number(this.quoteAdvSearchFields[1]);
            }
            if (this.quoteAdvSearchFields[2]) {
                advancedSearchJSONbody['createddate'] = this.quoteAdvSearchFields[2];
            }
            if (this.quoteAdvSearchFields[3]) {
                advancedSearchJSONbody['RFQ'] = this.quoteAdvSearchFields[3];
            }
            if (this.quoteAdvSearchFields[4]) {
                advancedSearchJSONbody['customer'] = Number(this.quoteAdvSearchFields[4]);
                }
            if (this.quoteAdvSearchFields[5]) {
                advancedSearchJSONbody['contact'] = Number(this.quoteAdvSearchFields[5]);
            }
            if (this.quoteAdvSearchFields[6]) {
                advancedSearchJSONbody['duedays'] = Number(this.quoteAdvSearchFields[6]);
            }
            if (this.quoteAdvSearchFields[7]) {
                advancedSearchJSONbody['duedate'] = this.quoteAdvSearchFields[7];
                }
            if (this.quoteAdvSearchFields[8]) {
                advancedSearchJSONbody['owner'] = Number(this.quoteAdvSearchFields[8]);
            }
            if (this.quoteAdvSearchFields[9]) {
                advancedSearchJSONbody['status'] = Number(this.quoteAdvSearchFields[9]);
            }
            if (this.quoteAdvSearchFields[10]) {
                advancedSearchJSONbody['expireddays'] = Number(this.quoteAdvSearchFields[10]);
            }
            if (this.quoteAdvSearchFields[11]) {
                advancedSearchJSONbody['expireddate'] = this.quoteAdvSearchFields[11];
            }

            console.log(advancedSearchJSONbody);
            this.commonService.notifyOther({ option: 'onAdvancedSearch', value: {page: 'quotes', data: advancedSearchJSONbody} });
            this.quoteAdvSearchFields = [];
        }
    }

    advSearchStart() {

        this.modalAdvancedSearchAction.emit({ action: 'modal', params: ['close'] });

        // Nav to the page the search is for. There is probably a better way to do this.
        switch (Number(this.searchselect)) {
            case 0: // Projects
            this.haveNewProjectSearchData = true;
                // if we're already on the page do the call to get search results
                if (this.router.url === '/projects') {
                    this.commonService.notifyOther({ option: 'getPageSearchData', value: 'projects'});
                } else {
                    this.service.setProjectSearchResultBool(true);
                    this.router.navigate(['/projects']);
                }
            break;
            case 1: // Quotes
            this.haveNewQuoteSearchData = true;
                // if we're already on the page do the call to get search results
                if (this.router.url === '/quote') {
                    this.commonService.notifyOther({ option: 'getPageSearchData', value: 'quotes'});
                } else {
                    this.service.setQuoteSearchResultBool(true);
                    this.router.navigate(['/quote']);
                }
            break;
        }

    }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/search/advanced/advancedsearch.component.ts